// A quick, lenient e-mail regex (good enough for front-end)
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

export const splitEmails = (raw: string) =>
  raw
    .split(/[,; \n\r]+/) // , ; space newline
    .map((e) => e.trim())
    .filter(Boolean);
